export const API_ENDPOINT = {
  SIGN_UP: 'signUp',
  LOGIN: 'login',
  // COUNTRY: "getallcountry",
  USER_INFO: 'user',
  SAVE_USER: "signUp",
  SAVE_SPECIES: 'saveSpecies',
  SPECIES_LIST: 'speciesList',
  SPECIES_UPDATE: 'speciesUpdate',
  SPECIES_DELETE: 'speciesDelete',
  SAVE_BREED: 'saveBreed',
  BREED_LIST: 'breedList',
  BREED_UPDATE: 'breedUpdate',
  BREED_DELETE: 'breedDelete',
  SAVE_CHILLING: 'saveChilling',
  CHILLING_LIST: 'chillingList',
  CHILLING_UPDATE: 'chillingUpdate',
  CHILLING_DELETE: 'chillingDelete',
  SAVE_ZONE: 'saveZone',
  ZONE_LIST: 'zoneList',
  ZONE_UPDATE: 'zoneUpdate',
  ZONE_DELETE: 'zoneDelete',
  SAVE_ROUTE: 'saveRoute',
  ROUTE_LIST: 'routeList',
  ROUTE_UPDATE: 'routeUpdate',
  ROUTE_DELETE: 'routeDelete',
  SAVE_SOCIETY: 'saveSociety',
  SOCIETY_LIST: 'societyList',
  SOCIETY_UPDATE: 'societyUpdate',
  SOCIETY_DELETE: 'societyDelete',
  SAVE_FARMER: 'saveFarmer',
  FARMER_LIST: 'farmerList',
  FARMER_UPDATE: 'farmerUpdate',
  FARMER_DELETE: 'farmerDelete',
  SAVE_SIRE: 'saveSire',
  SIRE_LIST: 'sireList',
  SIRE_UPDATE: 'sireUpdate',
  SIRE_DELETE: 'sireDelete',
  SAVE_STAFF: 'saveStaff',
  STAFF_LIST: 'staffList',
  STAFF_UPDATE: 'staffUpdate',
  STAFF_DELETE: 'staffDelete',
  SAVE_UNION: 'saveUnion',
  UNION_LIST: 'unionList',
  UNION_UPDATE: 'unionUpdate',
  UNION_DELETE: 'unionDelete',
  SAVE_DISTRICTS: 'saveDistricts',
  DISTRICTS_LIST: 'districtsList',
  DISTRICTS_UPDATE: 'districtsUpdate',
  DISTRICTS_DELETE: 'districtsDelete',
  SAVE_TASKS: 'saveTasks',
  TASKS_LIST: 'tasksList',
  TASKS_UPDATE: 'tasksUpdate',
  TASKS_DELETE: 'tasksDelete',
  SAVE_ANIMAL: 'saveAnimal',
  ANIMAL_LIST: 'animalList',
  ANIMAL_UPDATE: 'animalUpdate',
  ANIMAL_DELETE: 'animalDelete',
  SAVE_CONTAINERMASTER: 'saveContainermaster',
  CONTAINERMASTER_LIST: 'containermasterList',
  CONTAINERMASTER_UPDATE: 'containermasterUpdate',
  CONTAINERMASTER_DELETE: 'containermasterDelete',
  SAVE_MEDICINETYPE: 'saveMedicinetype',
  MEDICINETYPE_LIST: 'medicinetypeList',
  MEDICINETYPE_UPDATE: 'medicinetypeUpdate',
  MEDICINETYPE_DELETE: 'medicinetypeDelete',
  SAVE_NUTRIENTTYPE: 'saveNutrientType',
  NUTRIENTTYPE_LIST: 'nutrienttypeList',
  NUTRIENTTYPE_UPDATE: 'nutrienttypeUpdate',
  NUTRIENTTYPE_DELETE: 'nutrienttypeDelete',
  SAVE_NUTRIENT: 'saveNutrient',
  NUTRIENT_LIST: 'nutrientList',
  NUTRIENT_UPDATE: 'nutrientUpdate',
  NUTRIENT_DELETE: 'nutrientDelete',
  SAVE_FEEDGROUP: 'saveFeedgroup',
  FEEDGROUP_LIST: 'feedgroupList',
  FEEDGROUP_UPDATE: 'feedgroupUpdate',
  FEEDGROUP_DELETE: 'feedgroupDelete',
  SAVE_INGRADIANT: 'saveIngradiant',
  INGRADIANT_LIST: 'ingradiantList',
  INGRADIANT_UPDATE: 'ingradiantUpdate',
  INGRADIANT_DELETE: 'ingradiantDelete',
  SAVE_BODYWEIGHT: 'saveBodyWeight',
  BODYWEIGHT_LIST: 'bodyWeightList',
  BODYWEIGHT_UPDATE: 'bodyWeightUpdate',
  BODYWEIGHT_DELETE: 'bodyWeightDelete',
  SAVE_TASK_BREED: 'savetaskBreed',
  SAVE_SELECT_BREED: 'selectBreed',
  SAVE_Milk: 'saveMilk',
  Milk_LIST: 'milkList',
  Milk_UPDATE: 'milkUpdate',
  Milk_DELETE: 'milkDelete',
  SAVE_PREGNANCY: 'savePregnancy',
  PREGNANCY_LIST: 'pregnancyList',
  PREGNANCY_UPDATE: 'pregnancyUpdate',
  PREGNANCY_DELETE: 'pregnancyDelete',
  SAVE_DRUG_MASTER: 'saveDurgMaster',
  DRUG_MASTER_LIST: 'durgMasterList',
  DRUG_MASTER_UPDATE: 'durgMasterUpdate',
  DRUG_MASTER_DELETE: 'durgMasterDelete',
  SAVE_BODY_WEIGHT_LOT: 'saveBodyWeightLot',
  BODY_WEIGHT_LOT_LIST: 'bodyWeightLotList',
  BODY_WEIGHT_LOT_UPDATE: 'bodyWeightLotUpdate',
  BODY_WEIGHT_LOT_DELETE: 'bodyWeightLotDelete',
  SAVE_BODY_WEIGHT_INDIVIDUAL: 'saveBodyWeightIndividual',
  BODY_WEIGHT_INDIVIDUAL_LIST: 'bodyWeightIndividualList',
  BODY_WEIGHT_INDIVIDUAL_UPDATE: 'bodyWeightIndividualUpdate',
  BODY_WEIGHT_INDIVIDUAL_DELETE: 'bodyWeightIndividualDelete',
  SAVE_BODY_SCORE: 'saveBodyScore',
  BODY_SCORE_LIST: 'bodyScoreList',
  BODY_SCORE_UPDATE: 'bodyScoreUpdate',
  BODY_SCORE_DELETE: 'bodyScoreDelete',
  SAVE_SERVICE: 'saveServices',
  SERVICE_LIST: 'serviceList',
  SERVICE_UPDATE: 'servicesUpdate',
  SERVICE_DELETE: 'serviceDelete',


//rage
 //Rage.fan
 GET_ALL_COUNTRY: "getallcountry",
 GET_STATE: "getstate",
 GET_CITY: "getcity",
 SAVE_TOKEN:"saveToken",
 GET_TOKEN:"getToken",
 TOKEN_LOGO:"tokenlogo",
 UPDATE_TOKEN_LOGO:"updatetokenlogo",
 UPLOAD_VIDEO:"uploadvideo",
 REUPLOAED_VIDEO:"reUploadvideo",
 TOKEN_DISPLAY_LOGO:"tokenDisplayLogo",
 RE_TOKEN_DISPLAY_LOGO:"retokenDisplayLogo",
 TOKEN_CAPTURE_LOGO:"tokenCaptureLogo",
 RE_TOKEN_CAPTURE_LOGO:"retokenCaptureLogo",
 TOKEN_THREE_LOGO:"tokenthreeLogo",
 RE_TOKEN_THREE_LOGO:"retokenthreeLogo",
 SAVE_PRODUCTS:"saveproducts",
 PRODUCT_IMAGES:"productimages",
 GET_PRODUCTS:"getproducts",
 GET_PROMOCODEUSER:"promocodedata",


 ///

 SEND_ALLUSER:"sendAlluser",
SEND_PARTICULAR:"sendParticularuser",

SAVE_TESTDATA:"savetestdata",
GET_TESTDATA:"gettestdata",
UPDATE_TESTDATA:"testdataUpdate",
DELETE_TESTDATA:"testdataDelete",


  //User
  GET_USER_LIST: 'getUserList',
  USER_DELETE: 'userDelete',
  USER_UPDATE: 'userUpdate',
  USER_RESET_PASSWORD: 'userResetPassword',
  USER_INFO: 'getUserInfo'
}
